function bindBadSearchClickEffect() {
  $('a.bad-search').click(function () {
    $(this).toggle('highlight');
  });
}

function init() {
  bindBadSearchClickEffect();
}

$(init);

export default {
  init,
};
